
import request from '@/utils/request'
/*
npm菜单管理相关的API请求函数
*/
const api_name = '/portal/web/api/registration'

export default {

    //提交
    save(registration) {
        return request({
            url: `${api_name}/register`,
            method: 'post',
            data: registration
        })
    },

    //公司名称
    companiesOrg(org) {
        return request({
            url: `${api_name}/companies`,
            method: 'post',
            data: org
        })
    },

    //验证
    verification(registration){
        return request({
            url: `${api_name}/verification`,
            method: 'post',
            data: registration
        })
    },

    //验证公司名称是否超过三个人了
    verificationOrg(registration) {
        return  request({
            url: `${api_name}/verificationOrg`,
            method: 'post',
            data: registration
        })
    },

}
